var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHello(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 22,
    viewBox: "0 0 62 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0713 1.24275V20.3995H7.24123V13.2889C6.61327 13.2889 6.064 13.2354 5.53676 13.3204C5.36679 13.3487 5.14015 13.739 5.13701 13.9688C5.10396 15.8275 5.11969 17.6878 5.11655 19.5481C5.11497 19.8282 5.09136 20.1083 5.07248 20.5128H0V1.16406H5.041V8.02127H7.12004V1.24275H12.0713Z",
    fill: "#A4A4AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9192 5.76785C54.8909 3.39608 53.4886 1.71994 51.1766 1.17382C50.6478 1.04949 50.1095 0.95663 49.576 0.849609H48.0022C47.7535 0.901546 47.5064 0.988107 47.2546 1.00385C44.3162 1.18641 42.5268 3.06872 42.5236 5.99921C42.5221 8.77703 42.5221 11.5533 42.5236 14.3311C42.5268 18.1791 44.4658 20.3274 48.2839 20.7162C51.877 21.0813 54.8515 18.497 54.9113 14.8851C54.9617 11.8476 54.9554 8.80693 54.9192 5.76785ZM49.8042 14.4287C49.7979 15.1432 49.4029 15.5886 48.819 15.5886C48.2068 15.587 47.8054 15.1731 47.8023 14.4507C47.7897 11.8114 47.8023 9.17206 47.7944 6.53274C47.7913 5.87487 48.0824 5.48141 48.7419 5.42475C49.3572 5.37124 49.79 5.80248 49.8011 6.5107C49.8215 7.86892 49.8074 9.22872 49.8074 10.5869C49.8089 11.868 49.8168 13.1491 49.8042 14.4287Z",
    fill: "#A4A4AA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.537 1.47656H56.4692V14.3757H61.537V1.47656Z",
    fill: "#A4A4AA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5369 17.9955V18.9398C61.1718 20.0415 60.4053 20.7434 59.3335 21.1416H58.5466C57.3694 20.8206 56.4487 20.2162 56.2094 18.9209C55.9624 17.5784 56.7272 16.3572 58.0461 15.9432C59.3178 15.5451 60.6839 16.1573 61.2489 17.377C61.3433 17.5832 61.4409 17.7893 61.5369 17.9955Z",
    fill: "#A4A4AA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4592 5.70168V8.21668H22.2899V12.9382H18.4576V15.4548H22.666V20.4611H13.4575V1.23828H22.6786V5.70168H18.4592Z",
    fill: "#A4A4AA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9227 15.4623V20.4466H23.8489V1.22852H28.8663V15.4623H31.9227Z",
    fill: "#A4A4AA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5065 15.5012V20.4462H33.4421V1.23438H38.4469V15.5012H41.5065Z",
    fill: "#A4A4AA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHello);
export default __webpack_public_path__ + "static/media/hello.4a1241b29f85cf6efbd130f12a0b7596.svg";
export { ForwardRef as ReactComponent };